import React from 'react'
import { CustomTag } from 'src/components'
import { useTranslation } from 'next-i18next'
import { AdminSaleOffer } from 'src/core/models'
import styles from './AdminSaleOfferTypeColumn.module.scss'

const AdminSaleOfferTypeColumn: React.FC<{ offer: AdminSaleOffer }> = ({ offer }) => {
  const { t } = useTranslation()

  const tagType = {
    expired: 'default',
    accepted: 'success',
    rejected: 'error',
    open: 'processing'
  }[offer.status] || 'default'

  return <div className={styles.content}>
    <CustomTag
      text={t(`SalesOffer.${offer.type}`)}
      type='default'
      className={styles.tag}
      showIcon={false}
    />
    <CustomTag
      text={t(`SalesOffer.${offer.status}`)}
      type={tagType}
      className={styles.tag2}
      showIcon
    />
  </div>
}

export default AdminSaleOfferTypeColumn
